module.exports = __webpack_public_path__ + "media/images/partners/mosbilet-e26752476cea7a41117cf6c62c6c40dc.svg";